export default __webpack_public_path__ + "static/media/sad-illustration.9eb5e6bf.png";